import Container, { MobileModal as MobileContainer } from '~/components/Modal/Container/Container';

export default Container;

export { MobileContainer };
